<div class="is-flex is-flex-direction-column">
  @for (link of links(); track link.name) {
    @if (!link.role || hasRole(link.role)) {
      @if (link.callback) {
        <a
          class="has-text-centered has-text-primary"
          [attr.data-testid]="link.name"
          (click)="link.callback()"
          [translate]="link.name"
        ></a>
      } @else {
        <a
          class="has-text-centered has-text-primary"
          [routerLink]="[productLink()]"
          [attr.data-testid]="link.name"
          [queryParams]="link.param"
          [translate]="link.name"
        ></a>
      }
    }
  }
</div>
